import '@faceup/moment'
import { Device } from '@capacitor/device'
import { locales } from '@faceup/ui-base'
import { convertBasenameToLanguage } from '@faceup/utils'

const translations = {
  ant: locales,
}

export default translations

export const getDeviceInfo = async () => {
  const { platform } = await Device.getInfo()
  const { value: language } = await Device.getLanguageCode()

  return {
    platform,
    language: convertBasenameToLanguage(language),
  }
}
